<div class="top-menu-container flex-row-center">
  <div>
    <button mat-fab color="{{ mobileContainer.state === 'squash_default' ? 'accent' : 'primary'}}"
            (click)="mobileContainer.application.router.navigateByUrl('/squash')">😎{{mobileContainer.application.account.payload_parsed['connect_game_icon']}}</button>
    <label [class.top-menu-active-label]="mobileContainer.state === 'squash_default'">
<!--      {{'top_label_public' | GetLabelPipe}}-->
      {{mobileContainer.application.account.payload_parsed['connect_label']}}
    </label>
  </div>
  <div>
    <button mat-fab color="{{ mobileContainer.state === 'subscribe_events' ? 'accent' : 'primary'}}"
            (click)="mobileContainer.application.router.navigateByUrl('/squash/subscribe_events')">📢</button>
    <label [class.top-menu-active-label]="mobileContainer.state === 'subscribe_events'">
      {{'top_label_events' | GetLabelPipe}}
    </label>
  </div>
  <div *ngIf="mobileContainer.application.account.payload_parsed['has_cups']">
    <button mat-fab color="{{ mobileContainer.state === 'cups' ? 'accent' : 'primary'}}"
            (click)="mobileContainer.application.router.navigateByUrl('/squash/cups')">🏆</button>
    <label [class.top-menu-active-label]="mobileContainer.state === 'cups'">
      {{'top_label_cups' | GetLabelPipe}}
    </label>
  </div>
  <div>
    <button mat-fab color="{{ mobileContainer.state === 'classes' ? 'accent' : 'primary'}}"
            (click)="mobileContainer.application.router.navigateByUrl('/squash/classes')">👥</button>
    <label [class.top-menu-active-label]="mobileContainer.state === 'classes'">
      {{'players_groups' | GetLabelPipe}}
    </label>
  </div>
</div>
